import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';

const YearFilter = ({ dispatch, year, changeDateActionName }) => (
  <div style={{ width: '180px' }}>
    <Datetime
      locale="es"
      renderInput={(props) => <input {...props} className="rs-input" />}
      dateFormat="YYYY"
      timeFormat={false}
      value={year}
      onChange={(newDate) => {
        if (moment(newDate, 'YYYY', true).isValid()) {
          dispatch({
            type: changeDateActionName,
            payload: newDate,
          });
        }
      }}
      isValidDate={(date) => moment(date).isSameOrBefore(moment(), 'year')}
      closeOnSelect
    />
  </div>
);

YearFilter.propTypes = {
  dispatch: PropTypes.func.isRequired,
  year: PropTypes.instanceOf(moment).isRequired,
  changeDateActionName: PropTypes.string.isRequired,
};

export default YearFilter;
